import { computed, watch } from 'vue'
import { useTheme } from 'vuetify'
import { useAppStore } from '@/stores/app.store'

export function useThemeSwitch() {
  const appStore = useAppStore()
  const theme = useTheme()

  const isDark = computed(() => appStore.darkMode)

  function applyTheme() {
    theme.change(appStore.darkMode ? 'tamiDark' : 'tamiLight')
  }

  function toggleTheme() {
    appStore.toggleDarkMode()
  }

  watch(() => appStore.darkMode, applyTheme, { immediate: true })

  return { isDark, toggleTheme }
}
